import * as React from "react";

import {
  Icon,
  StyledButton
} from "./style";


const PrevCircleButton = ({
  ...props
})=> {
  return (
    <StyledButton
      { ...props }
    >
      <Icon />
    </StyledButton>
  )
}


export default PrevCircleButton;
